module.exports = __webpack_public_path__ + "img/fruit.1e91cc94.svg";